export default __webpack_public_path__ + "static/media/aws-cloudwatch.22e36d073e5c958dc15430a1e6fe4ad6.svg";